exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TextDialog__dialog___3Fhlj {\n  width: 80vw;\n  height: 80vh;\n  padding: 15px;\n  display: flex;\n  flex-direction: column; }\n  .TextDialog__dialog___3Fhlj .TextDialog__title___1HLRj {\n    margin: 0;\n    padding: 0;\n    color: #50E3C2;\n    margin-bottom: 5px; }\n  .TextDialog__dialog___3Fhlj .TextDialog__content___1k-QY {\n    display: block;\n    flex-shrink: 1;\n    overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"dialog": "TextDialog__dialog___3Fhlj",
	"title": "TextDialog__title___1HLRj",
	"content": "TextDialog__content___1k-QY"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Dialogs/TextDialog/TextDialog.scss
// module id = 680
// module chunks = 0